function render( weightedAverageCost?: { amount: number, currencyCode: string } ) {
	return weightedAverageCost?.amount ? new Intl.NumberFormat( 'en-US', {
		style: 'currency',
		currency: weightedAverageCost?.currencyCode ?? 'USD',
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	} ).format( weightedAverageCost.amount ) : ''
}

export default {
	field: 'weightedAverageCost',
	name: 'WAC',
	description: 'Weighted Average Cost',
	width: '90px',
	align: 'right',
	render,
}
